var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"btmComp",staticClass:"logo-bottom"},[_c('g-img',{staticClass:"img c-p-b-20",attrs:{"src":require('i/copyright_icon.png'),"size":"224","normal":"","alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }